import React, {useState, useContext, useEffect} from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonContent, IonButton, IonImg, IonFooter } from '@ionic/react';

import '../../../../css/qavaApp.css';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


export function ViewAttachement_ExpenseImageModal(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);



    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
    <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonGrid className='appHeader'>
                <IonRow>
                    <IonCol>
                        {props.data.paymentType}
                    </IonCol>
                    <IonCol>
                        {props.data.totalAmount}
                    </IonCol>
                </IonRow>
            </IonGrid>
            <IonGrid  class='appGridContent'>
                <IonRow>
                    <IonCol>
                        {/*<IonImg src={props.data.fileLocation}></IonImg>*/}
                        <IonImg src={`/api/image/${props.data.fileLocation}/${schema}`} />
                    </IonCol>
                </IonRow>
            </IonGrid>
            <IonFooter className='modal_footer_button_center'>
                    <IonButton onClick={closeModalHandler}> Close </IonButton>
            </IonFooter>
        </IonModal>) : null}
    </React.Fragment>
    )
}